import { Contact } from '../contact/contact';

export type PatientStatus = 'initial' | 'regular';

export interface Patient {
  id: string;
  user: any;
  profile: any;
  firstName: string;
  lastName: string;
  lastAppointment: string;
  nextAppointment: string;
  email: string;
  phone: string;
  address: string;
  pronouns: string;
  additionalDetailsForTherapist: string;
  initialVisitReasons: string;
  locationAddress: string;
  birthDate: string;
  status: PatientStatus;
  contacts: Contact[];
}

export const enum LevelOfCareEnum {
  TalkTherapy = 'talkTherapy',
  MedicationManagement = 'medicationManagement',
  Both = 'both',
}
